import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';

import Layout from "../components/UI/Layout/Layout";
import CerticatesList from "../components/Certificates/CerticatesList";
import CertificatesForm from "../components/Certificates/CertificatesForm";
import { loadCertificates } from "~/components/Certificates/actions";
import { LoadingTopBar } from "~/components/UI/LoadingTopBar";
import { LocalCacheHandler } from '~/utils/local-cache-handler';
import { CACHE_ACTIONS } from '~/constants/cache-actions.constants';
import usePersistedFilters from '~/_shared/hooks/usePersistedFilters';
import {
  CERTIFICATES_FILTERS_KEY,
  getDefaultCertificatesFilters,
  getCertificatesRequest,
  isSameCertificatesRequest,
} from '~/components/Certificates/filters';

export var ScreensCertificates = function() {
  var dispatch = useDispatch();
  var pathname = useLocation().pathname;

  var _isLoading = useState(true);
  var isLoading = _isLoading[0];
  var setIsLoading = _isLoading[1];

  var _drawer = useState({ isVisible: false, data: null });
  var drawer = _drawer[0];
  var setDrawer = _drawer[1];

  // Filters kept across refreshes for a few minutes (per tenant/user/page).
  var persisted = usePersistedFilters(CERTIFICATES_FILTERS_KEY, getDefaultCertificatesFilters);
  var applied = persisted.filters;
  var isFirstLoad = useRef(true);

  // Loads the restored (or default) filter on mount, and again whenever the
  // server-side filters (year, filter by) change.
  useEffect(function() {
    loadData();
  }, [applied.year, applied.filterBy]);

  function loadData() {
    var firstLoad = isFirstLoad.current;
    isFirstLoad.current = false;
    // The IndexedDB cache is keyed by route only, so it only ever holds the
    // default year; using it for another filter would flash wrong data.
    var usesCache = isSameCertificatesRequest(applied, persisted.defaults);
    var requestParams = Object.assign({ showLoading: false }, getCertificatesRequest(applied));

    setIsLoading(true);
    var cacheLoad = firstLoad && usesCache
      ? LocalCacheHandler.load({
        actionName: CACHE_ACTIONS.certificates,
        dispatch: dispatch,
        pathname: pathname
      })
      : Promise.resolve();

    return cacheLoad.then(function() {
      return dispatch(loadCertificates(requestParams));
    }).then(function(result) {
      if (!usesCache) return undefined;
      return LocalCacheHandler.save({
        pathname: pathname,
        data: result.payload.data
      });
    }).catch(function(error) {
      console.log(error);
    }).then(function() {
      setIsLoading(false);
    });
  }

  function showDrawer(data) {
    setDrawer({ isVisible: true, data: data || null });
  }

  function hideDrawer() {
    setDrawer({ isVisible: false, data: null });
  }

  return (
    <div>
      <LoadingTopBar isActive={isLoading} />
      <Layout>
        <CerticatesList
          showEdit={showDrawer}
          showModal={showDrawer}
          persisted={persisted}
          isLoading={isLoading}
        />
        <CertificatesForm
          visible={drawer.isVisible || drawer.data}
          onClose={hideDrawer}
          data={drawer.data}
          showEdit={showDrawer}
        />
      </Layout>
    </div>
  );
};
